import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { ABOUT_US_CONFIG } from './about-us.config';
import store from '../../redux/store/store';
import { changeHead } from '../../redux/head/headActions';
import { MHero, MHeroImageSlider } from '../../components/molecules';
import { OPartners } from '../../components/organisme';

function PartnersPage({ changeHeadFunc, intl }) {
	useEffect(() => {
		changeHeadFunc({
			title: intl.formatMessage({ id: pageConfig.partners.title }),
			description: intl.formatMessage({ id: pageConfig.partners.description }),
			showSocialMedia: true,
		});
	});

	const type = store.getState().head.navigation;
	const partners = get(ABOUT_US_CONFIG.partners[type], 'partners', []);
	const images = get(ABOUT_US_CONFIG.partners[type], 'slider', [undefined]);

	let hero = (
		<MHero
			img={images[0]}
			currentPage="BREAD_CRUMB.PARTNERS"
			className="a-hero--bottom-align"
		/>
	);

	if (images && images.length > 1) {
		hero = (
			<MHeroImageSlider
				items={images}
				currentPage="BREAD_CRUMB.PARTNERS"
				className="a-hero--bottom-align"
			/>
		);
	}

	return (
		<section>
			{hero}
			<article className="section-xx layout-body">
				<OPartners
					items={partners}
				/>
			</article>
		</section>
	);
}

PartnersPage.propTypes = {
	changeHeadFunc: PropTypes.func.isRequired,
};

export default withRouter(connect(null, {
	changeHeadFunc: changeHead,
})(injectIntl(PartnersPage)));



// WEBPACK FOOTER //
// ./src/pages/about-us/partners.page.js